export const EMAIL_SIGNUP = 'EMAIL_SIGNUP';
